export default __webpack_public_path__ + "assets/icons/btn-download.8602edca.svg";